import isDesktop from '../../common/utils/desktop/isDesktop';
import invokeDesktopFunction from '../../common/utils/desktop/invokeDesktopFunction';
import { desktopFuncNames } from '../../common/constants/desktop';

export default () => {
  if (isDesktop()) {
    invokeDesktopFunction(desktopFuncNames.reloadPage);
  } else {
    window.location.reload();
  }
};
